import { render, staticRenderFns } from "./CProcessBlock.vue?vue&type=template&id=5e7b794a&"
import script from "./CProcessBlock.vue?vue&type=script&lang=js&"
export * from "./CProcessBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports